export const styleToParams = {
    items: [],
    separator: "|",
    isColor: (value) => {
        return /^#[0-9a-f]{6}$/i.test(value.toString());
    },
    toColor: (value) => {
        return '0x' + value.slice(1);
    },
    parse: (json) => {
     
        const items = []
        const separator = "|";

        function isColor(value) {
            return /^#[0-9a-f]{6}$/i.test(value.toString());
        }
        function toColor(value) {
            return '0x' + value.slice(1);
        }

        for (var i = 0; i < json.length; i++) {
            const item = json[i],
                // hasFeature = item.hasOwnProperty('featureType'),
                // hasElement = item.hasOwnProperty('elementType'),
                hasFeature = Object.prototype.hasOwnProperty.call(item, 'featureType'),
                hasElement = Object.prototype.hasOwnProperty.call(item, 'elementType'),
                stylers = item.stylers;

            let target = '',
                style = '';

            if (!hasFeature && !hasElement) {
                target = 'feature:all';
            } else {
                if (hasFeature) {
                    target = 'feature:' + item.featureType;
                }
                if (hasElement) {
                    target = target ? target + separator : '';
                    target += 'element:' + item.elementType;
                }
            }

            for (var s = 0; s < stylers.length; s++) {
                var styleItem = stylers[s],
                    key = Object.keys(styleItem)[0]; // there is only one per element

                style = style ? style + separator : '';
                style +=
                    key +
                    ':' +
                    (isColor(styleItem[key]) ? toColor(styleItem[key]) : styleItem[key]);
            }

            items.push(target + separator + style);

        }
        return items;
    },
    get: (items) => {
        return '&style=' + items.join('&style=');
    },
  };


export default {};
